import React, { useCallback } from 'react';
import { COLUMN_TYPE } from '../../../Shared/ListView/helper';
import i18n from '../../../Shared/Translation/i18n';
import ListView from '../../../Shared/ListView';
import InputCont from '../../../Shared/Form/InputCont';
// import DetailView from '../../Shared/DetailView';
import useDetail from '../../../Shared/useDetail';
import { ApiUrl } from '../../../project/Defines.js';
import { dispatchCustomEvent, EVENT_NAME } from '../../../project/utilities';
import Langauges from '../../SalesNetworkConfig/Languages';
import Applications from '.././Applications.js';
import Systems from '.././Systems';
import Screens from '.././Screens';
import { Ajax } from '../../../components/Ajax';
import { message } from 'antd';

import { hideLoader, showLoader } from '../../../Shared/Loader';
import Services from '../Services.js';
import Inputs from '../Inputs.js';
import Filters from '../Filters.js';
import Links from '../Links.js';

const loaderName = 'CONTACT_LOADER';
const columns = [
    {
        text: 'text.question',
        field: 'question',
        type: COLUMN_TYPE.TEXT
    },
    {
        text: 'text.answer',
        field: 'answer',
        type: COLUMN_TYPE.TEXT
    },
    {
        type: COLUMN_TYPE.ACTION
    }
];
export default function ThercodimSalesNetworksConfig() {
    const listUpdateEvent = EVENT_NAME.SALES_NETWORK_LIST_UPDATE;

    const { dataItem, setDataItem, updateData, hasChanges, closePopup, detailRef, onChangeData, validation } = useDetail({
        data: {},
        updateUrl: ApiUrl.SalesNetworkCurrentUpdate,
        dataLoadUrl: ApiUrl.SalesNetworkGetData,
        listUpdateEvent
    });

    const updateSuccessCallback = useCallback((response) => {
        if (detailRef.current) {
            setDataItem(response);
        }

        dispatchCustomEvent(listUpdateEvent, { action: 'update' });
        closePopup();
    }, [setDataItem, closePopup, detailRef, listUpdateEvent]);

    const dataChange = (e) => {
        updateData(updateSuccessCallback, null, { overrideData: { [e.target.name]: e.target.checked } });
    };

    const updateBrand = (e) => {
        Ajax.post({
            url: ApiUrl.SalesNetworkBrandUpdate,
            data: { brands: e },
            success: function (response) {
                setDataItem({ ...dataItem, brands: e })
            },
        })
    }

    const updateContact = (e) => {
        if (dataItem) {
            showLoader(loaderName);
            Ajax.post({
                url: ApiUrl.SalesNetworkUpdate,
                data: dataItem,
                success: function (response) {
                    if (response && !response.HasError) {
                        hideLoader(loaderName);
                        message.success('Data has been updated!');
                        setDataItem(response);
                    } else {
                        hideLoader(loaderName);
                        message.error();
                    }
                },
            })
        }
    }

    const typeOfBrandSelect = dataItem && dataItem.brands && dataItem.brands.length > 1 ? 'multiselect' : 'select';

    return <>
        {dataItem &&
            <div className="form_container">
                <div className="section_group">
                    <div className="sections ">
                        <div className="form_fields"><div className="section_title"><text>{i18n("text.global_information")}</text></div><div className="form_separator"></div></div>
                        <cont><InputCont label='text.connection_required' inputProps={{ validation, name: "thercodim_requiredConnexion", type: 'checkbox', value: dataItem.thercodim_requiredConnexion, onChange: dataChange }} /></cont>
                        <cont><InputCont label='text.price_display' inputProps={{ validation, name: "thercodim_showPrice", type: 'checkbox', value: dataItem.thercodim_showPrice, onChange: dataChange }} /></cont>
                        <InputCont label="text.brand"
                            inputProps={{
                                name: 'brands',
                                type: typeOfBrandSelect,
                                value: dataItem.brands,
                                valuelist: 'brands',
                                onChange: updateBrand,
                                disabled: true
                            }} />
                        <InputCont
                            label='text.contact'
                            inputProps={{ name: "thercodim_contact", type: 'textarea', maxLength: "250", value: dataItem.thercodim_contact, onChange: onChangeData }}
                        />
                    </div>
                </div>

                <Langauges isThercodim={true} defaultUpdateUrl={ApiUrl.ThercodimSalesNetworkDefaultLangugeUpdate} updateUrl={ApiUrl.ThercodimSalesNetworkCurrentLangugesUpdate} />
                <Applications isThercodim={true} />
                <Systems isThercodim={true} />
                <Services />
                <Screens requireSSO={dataItem.thercodim_requiredConnexion} />
                <Inputs />
                <Filters />
                <Links isThercodim={true} />

            </div>}
        <toolbar>
            <wrap>
                <action right=''>
                    <div
                        onClick={updateContact}
                        className={hasChanges ? ' button primary' : 'button'}>
                        <icon>save</icon>{i18n('text.save')}
                    </div>
                </action>
            </wrap>
        </toolbar>
    </>
}